import { Box, HStack } from '@bpba/ui-components';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { getPageRange } from '../../utils/pagination';
import { ArrowBtn, Ellipsis, PageBtn, ResponsiveGapBox } from './styled';

type Props = {
  loading: boolean;
  currentPage: number;
  totalPages: number;
  onPrev: () => void;
  onNext: () => void;
  onGoTo: (page: number) => void;
};

export const Paginator = ({ loading, currentPage, totalPages, onPrev, onNext, onGoTo }: Props) => {
  const visible = !loading && totalPages > 1;
  return (
    <ResponsiveGapBox display="flex" flexDirection={['column', null, 'row']} minHeight="32px">
      <Box display={['none', null, 'none', 'none', 'block']} width={['0', '0', '0', '0', '28%']} />
      <HStack
        width={['100%', '100%', '100%', '100%', '72%']}
        justifyContent="center"
        alignItems="center"
        role="navigation"
        aria-label="Paginación de informes"
        aria-controls="informes-tabla"
        style={{ gap: '4px', visibility: visible ? 'visible' : 'hidden' }}
      >
        <ArrowBtn type="button" disabled={currentPage === 1} $disabled={currentPage === 1} onClick={onPrev} aria-label="Página anterior">
          <MdChevronLeft size={18} />
        </ArrowBtn>
        {getPageRange(currentPage, totalPages).map((p, i) =>
          p === '...' ? (
            <Ellipsis key={`ellipsis-${i}`}>...</Ellipsis>
          ) : (
            <PageBtn
              key={p}
              type="button"
              $active={p === currentPage}
              onClick={() => onGoTo(p)}
              aria-label={`Página ${p}`}
              aria-current={p === currentPage ? 'page' : undefined}
            >
              {p}
            </PageBtn>
          )
        )}
        <ArrowBtn
          type="button"
          disabled={currentPage === totalPages}
          $disabled={currentPage === totalPages}
          onClick={onNext}
          aria-label="Página siguiente"
        >
          <MdChevronRight size={18} />
        </ArrowBtn>
      </HStack>
    </ResponsiveGapBox>
  );
};
